import type { CaipAccount } from '../common/mod.js';

import { AccountId } from 'caip';

import { CAIP_NAMESPACE } from './constants.js';

export function formatAccountsToCAIP(accounts: string[], chainId: string) {
  return accounts.map(
    (account) =>
      AccountId.format({
        address: account.toString(),
        chainId: {
          namespace: CAIP_NAMESPACE,
          reference: chainId,
        },
      }) as CaipAccount
  );
}
